import React from "react"
import Img from "gatsby-image"
import { DiscussionEmbed } from "disqus-react"
import Bio from "./Bio"
import NewsletterForm from "./NewsletterForm"
import {
  Row,
  BlogPostContainer,
  PostHeader,
  FeaturedImageContainer,
  BlogTitle,
  PostDetailsText,
  ExternalLink,
  SeparatorText,
  PrevNextPostUL,
  OrangeLink,
  DisqusContainer,
} from "./styles"

const BlogPost = ({
  title,
  date,
  postHTML,
  previousPost,
  nextPost,
  timeToRead,
  featuredImgFluid,
  disqusConfig,
}) => (
  <BlogPostContainer>
    <article>
      <PostHeader>
        <BlogTitle>{title}</BlogTitle>
        <PostDetailsText>{`${date} • ${timeToRead} min read`}</PostDetailsText>
        {featuredImgFluid && (
          <FeaturedImageContainer>
            <Img fluid={featuredImgFluid} />
          </FeaturedImageContainer>
        )}
      </PostHeader>
      <section dangerouslySetInnerHTML={{ __html: postHTML }} />
    </article>
    <Row>
      <ExternalLink
        href="https://twitter.com/ApolloAnumitha"
        target="_blank"
        rel="noopener"
      >
        Discuss on twitter
      </ExternalLink>
      <SeparatorText>{" • "}</SeparatorText>
      <ExternalLink href="mailto:anumithaapollo12@gmail.com">
        Email me
      </ExternalLink>
    </Row>
    <DisqusContainer>
      <DiscussionEmbed {...disqusConfig} />
    </DisqusContainer>
    <Bio />
    <nav>
      <PrevNextPostUL>
        <li>
          {previousPost && (
            <OrangeLink to={`blog/${previousPost.fields.slug}`} rel="prev">
              ← {previousPost.frontmatter.title}
            </OrangeLink>
          )}
        </li>
        <li>
          {nextPost && (
            <OrangeLink to={`blog/${nextPost.fields.slug}`} rel="next">
              {nextPost.frontmatter.title} →
            </OrangeLink>
          )}
        </li>
      </PrevNextPostUL>
    </nav>
    <NewsletterForm />
  </BlogPostContainer>
)

export default BlogPost
